import { z } from "zod";

import { branded } from "@/lib/helpers/branded-helper";

export const heatPumpBrandDtoSchema = z.object({
  id: branded.heatPumpBrandId,
  name: z.string(),
  status: z.enum(["VALIDATED", "NOT_VALIDATED"]),
});

export type THeatPumpBrandDto = z.infer<typeof heatPumpBrandDtoSchema>;
